import { Card } from "@volca/ui/components/ui/card";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { documentCategory } from "./document-categories";
import { DocumentExampleList } from "./document-example-list";
import { type OnboardingDocumentType } from "./types";

const DOCUMENT_GUIDANCE_TITLE = "What to send";

const AskList = ({ asks }: { asks: readonly string[] }) => (
  <ul className="ml-4 list-disc space-y-2 marker:text-subtle">
    {asks.map((ask) => (
      <li key={ask}>
        <Text tone="muted">{ask}</Text>
      </li>
    ))}
  </ul>
);

const FORMAT_NOTE =
  "Send spreadsheets as files rather than printouts, so we can see the formulas. Photos of a printed plan are fine.";

// The reference material for the step they are on. One padded container rather than
// CardHeader plus CardContent, which stack their own padding and leave the title floating
// above what it introduces; and the examples sit at the top right, level with the title,
// so the card is as short as its content allows.
export const DocumentGuidance = ({
  type,
}: {
  type: OnboardingDocumentType;
}) => {
  const category = documentCategory(type);

  return (
    <Card className="w-full gap-0 p-6">
      <Stack
        direction="row"
        gap={8}
        align="start"
        className="w-full flex-col sm:flex-row"
      >
        <Stack gap={4} align="stretch" className="min-w-0 flex-1">
          <Text variant="title">{DOCUMENT_GUIDANCE_TITLE}</Text>
          <AskList asks={category.asks} />
          <Text variant="caption" tone="muted">
            {FORMAT_NOTE}
          </Text>
        </Stack>

        <Stack align="start" gap={4} className="w-full shrink-0 sm:w-64">
          <DocumentExampleList examples={category.examples} />
        </Stack>
      </Stack>
    </Card>
  );
};
